import { Box, FormControl, MenuItem, TextField } from '@mui/material'
import RegularButton from 'components/CustomButtons/Button'
import { useForm } from 'hooks/useForm'
import React, { memo, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  deleteComoDataTank,
  createNewComoDataTank,
  editComoDataTank,
  getCapacityTanks,
} from 'redux/actions/comoDataTanks/comoDataTanksActions'
import { AutocompleteComponent } from 'components/Autocomplete/AutocompleteComponent'
import { initialValues, requiredValues } from './inputValues'

const blue = '#0055aa'

export const FormComoDataTankEdit = memo((props) => {
  const { handleClose } = props
  const { station: stationsSelected, comoDataTankSelected, addMode, deleteMode, brandsTank, capacitiesTank } = useSelector(state => state.comoDataTanks)
  const { stationsList } = useSelector(state => state.companies);
  const {
    inputValues,
    handleInputOnChange,
    handleNewValues,
    setValues,
    errors,
    runValidates
  } = useForm(initialValues, requiredValues)
  const dispatch = useDispatch()
  const { station, brand, serie, capacity, fixedAssetNum, description, status } = inputValues

  const handleSubmit = () => {
    if (deleteMode) {
      dispatch(deleteComoDataTank(comoDataTankSelected.id))
      handleClose()
      return
    }
    if (runValidates()) return;
    const newValues = {
      ...comoDataTankSelected,
      idStation: station?.id,
      brand: brand?.id,
      brandName: brand?.name,
      serie,
      capacity: capacity?.capacity,
      fixedAssetNum,
      description,
      status
    }

    if (addMode) {
      dispatch(createNewComoDataTank(newValues, handleClose))
    } else {
      dispatch(editComoDataTank(comoDataTankSelected.id, newValues, handleClose))
    }
  }

  const handleBrand = (e) => {
    setValues({ brand: e.brand, capacity: '' })
    if (e.brand?.id) {
      dispatch(getCapacityTanks(e.brand?.id))
    }
  }


  useEffect(() => {
    if (!addMode && comoDataTankSelected) {
      if (!capacitiesTank || capacitiesTank.length === 0) {
        dispatch(getCapacityTanks(comoDataTankSelected?.idBrand))
      }
      handleNewValues({
        station: stationsList.filter(obj => obj.id === comoDataTankSelected.idStation)[0],
        serie: comoDataTankSelected.serie,
        brand: brandsTank?.find(brand => brand?.id === comoDataTankSelected.idBrand),
        capacity: capacitiesTank?.find(capacity => capacity?.capacity === comoDataTankSelected.capacity),
        fixedAssetNum: comoDataTankSelected.fixedAssetNum,
        description: comoDataTankSelected.description,
        status: comoDataTankSelected.status ?? ''
      })
    } else if (stationsSelected?.id) {
      handleNewValues({
        station: stationsSelected
      })
    }
  }, [comoDataTankSelected, stationsSelected, capacitiesTank])

  return (
    <>
      <FormControl fullWidth style={{ display: 'flex', gap: 10, marginTop: 20 }} onSubmit={handleSubmit}>
        <AutocompleteComponent
          name="station"
          value={station}
          options={stationsList}
          label="Planta *"
          handleValues={handleNewValues}
          disabled={deleteMode || (!deleteMode && !addMode) || (stationsSelected?.id && !comoDataTankSelected?.idStation)}
          textFieldProps={{
            error: errors.station,
            helperText: errors.station,
          }}
        />
        <AutocompleteComponent
          name="brand"
          value={brand}
          options={brandsTank}
          label="Marca *"
          handleValues={handleBrand}
          disabled={deleteMode}
          textFieldProps={{
            error: errors.brand,
            helperText: errors.brand,
          }}
        />
        <TextField
          type="text"
          label="Serie *"
          name="serie"
          value={serie}
          disabled={deleteMode}
          onChange={handleInputOnChange}
          variant="outlined"
          error={errors.serie}
          helperText={errors.serie}
        />
        <TextField
          type="text"
          label="Activo Fijo *"
          name="fixedAssetNum"
          value={fixedAssetNum}
          disabled={deleteMode}
          onChange={handleInputOnChange}
          variant="outlined"
          error={errors.fixedAssetNum}
          helperText={errors.fixedAssetNum}
        />
        <AutocompleteComponent
          name="capacity"
          value={capacity}
          options={capacitiesTank}
          label="Capacidad *"
          handleValues={handleNewValues}
          disabled={deleteMode || !brand?.id}
          textFieldProps={{
            error: errors.capacity,
            helperText: errors.capacity,
          }}
        />
        <TextField
          select
          label="Estatus"
          name="status"
          value={status}
          disabled={deleteMode || addMode || status === 'ASIGNADO'}
          onChange={handleInputOnChange}
          variant="outlined"
        >
          {status === 'NUEVO' && <MenuItem value="NUEVO">Nuevo</MenuItem>}
          <MenuItem value="NO_ASIGNADO">No asignado</MenuItem>
          <MenuItem value="FUERA_DE_SERVICIO">Fuera de servicio</MenuItem>
          {status === 'ASIGNADO' && <MenuItem value="ASIGNADO">Asignado</MenuItem>}
        </TextField>
        <TextField
          type="text"
          multiline
          rows={4}
          label="Descripción *"
          name="description"
          value={description}
          disabled={deleteMode}
          onChange={handleInputOnChange}
          variant="outlined"
          error={errors.description}
          helperText={errors.description}
        />
        <Box sx={{ display: 'flex', justifyContent: "flex-end", gap: 8, }}>
          <RegularButton variant="contained" color="danger" onClick={handleClose}>Cancelar</RegularButton>
          <RegularButton
            variant="contained"
            color="facebook"
            style={{ backgroundColor: blue, color: 'white' }}
            onClick={handleSubmit}
          >
            {
              addMode
                ? 'Agregar'
                : deleteMode ? 'Eliminar'
                  : 'Guardar'
            }
          </RegularButton>
        </Box>
      </FormControl>
    </>
  )
})
